import { useDispatch, useSelector } from 'react-redux';
import { useContext, useEffect } from 'react';
import { getMeasurement } from '../../../store/slices/measurementsSlice/action';
import { MeasuremntsContext } from '../Context/MeasuremntsContext';

export const useMeasurementsModal = (onHideModal) => {
    const { isShowModal, currentCardId, modalLoading, isEdited } = useSelector(
        (state) => state.measurementsReducer
    );
    const {
        setImageList,
        setOpeningsDelete,
        setAdditionallyDelete,
        setImagesDelete,
        setErrorsInput,
    } = useContext(MeasuremntsContext);
    const dispatch = useDispatch();
    useEffect(() => {
        if (currentCardId) {
            dispatch(getMeasurement(currentCardId));
        }
    }, [currentCardId]);

    useEffect(() => {
        return () => {
            setErrorsInput({ name: null, additionallyName: {} });
            setImageList([]);
            setOpeningsDelete([]);
            setAdditionallyDelete([]);
            setImagesDelete([]);
        };
    }, []);

    useEffect(() => {
        const handler = (event) => {
            const isSidebarOrNavigation = event.target.closest('.sidebar, .navbar');

            if (!isSidebarOrNavigation) {
                onHideModal(isEdited);
            }
        };

        document.addEventListener('click', handler);
        return () => {
            document.removeEventListener('click', handler);
        };
    }, [isEdited]);

    return { isShowModal, currentCardId, modalLoading, isEdited };
};
